// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/helpers.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__fullWidth___nkLI_ {
  width: 100%;
}

.styles__header___SKKTI {
  align-items: center;
  margin-bottom: 16px;
}

.styles__title___PGmN3 {
  margin: 0;
}

.styles__newAccountButton___fWaV1 {
}

.styles__contentContainer___slD3A {
  padding-bottom: 20px;
  padding-top: 20px;
}

.styles__valueAlert___myFAg {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
  font-weight: bold;
}

.styles__truncatedCell___xOwZH {
  display: block;
  max-width: 190px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/ActionQueue/styles.css"],"names":[],"mappings":"AAIA;EACE,WAAW;AACb;;AAEA;EAEE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;AAEA;;AAEA;EAEE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,mDAAY;EAEZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB","sourcesContent":["@value helpers: \"styles/helpers.css\";\n@value colors: \"styles/colors.css\";\n@value gtRed from colors;\n\n.fullWidth {\n  width: 100%;\n}\n\n.header {\n  composes: flexSB from helpers;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.title {\n  margin: 0;\n}\n\n.newAccountButton {\n  composes: button from helpers;\n}\n\n.contentContainer {\n  composes: content-container from helpers;\n  padding-bottom: 20px;\n  padding-top: 20px;\n}\n\n.valueAlert {\n  color: gtRed;\n  composes: value from helpers;\n  font-weight: bold;\n}\n\n.truncatedCell {\n  display: block;\n  max-width: 190px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `"styles/helpers.css"`,
	"colors": `"styles/colors.css"`,
	"gtRed": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]}`,
	"fullWidth": `styles__fullWidth___nkLI_`,
	"header": `styles__header___SKKTI ${___CSS_LOADER_ICSS_IMPORT_1___.locals["flexSB"]}`,
	"title": `styles__title___PGmN3`,
	"newAccountButton": `styles__newAccountButton___fWaV1 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["button"]}`,
	"contentContainer": `styles__contentContainer___slD3A ${___CSS_LOADER_ICSS_IMPORT_1___.locals["content-container"]}`,
	"valueAlert": `styles__valueAlert___myFAg ${___CSS_LOADER_ICSS_IMPORT_1___.locals["value"]}`,
	"truncatedCell": `styles__truncatedCell___xOwZH`
};
export default ___CSS_LOADER_EXPORT___;
